// How people earn on BuildersLab — referral commissions and marketplace sales —
// read from the same file the server books earnings from
// (builderslab/shared/earnings.json), so a page can never promise a rate the
// ledger does not apply. Never hardcode one of these numbers in a component.

import EARNINGS from '../../builderslab/shared/earnings.json';

export { EARNINGS };

export const REFERRAL = EARNINGS.referral;
export const MARKETPLACE = EARNINGS.marketplace;
export const PAYOUT_MINIMUM_USD = EARNINGS.payoutMinimumUsd;
export const PAYOUT_METHODS = EARNINGS.payoutMethods;

/** 0.2 → "20%". */
export function percent(rate) {
  return `${Math.round((Number(rate) || 0) * 100)}%`;
}

/** The referral discount a buyer gets, as a percentage string. */
export const REFERRAL_DISCOUNT = percent(REFERRAL.discountRate);

/** The lowest and highest commission rates, e.g. "20%–40%". */
export function commissionRange() {
  const rates = (REFERRAL.tiers || []).map(t => t.rate);
  if (!rates.length) return '0%';
  const lo = Math.min(...rates);
  const hi = Math.max(...rates);
  return lo === hi ? percent(lo) : `${percent(lo)}–${percent(hi)}`;
}

/** "1–10", "11–50", "51+" for each tier, from the configured thresholds. */
export function tierRanges() {
  const tiers = [...(REFERRAL.tiers || [])].sort((a, b) => a.minCustomers - b.minCustomers);
  return tiers.map((t, i) => {
    const from = Math.max(t.minCustomers, 1);
    const next = tiers[i + 1];
    return { ...t, range: next ? `${from}–${next.minCustomers - 1}` : `${from}+` };
  });
}

/** Category id → label, with "Other" for anything unknown. */
export function categoryLabel(id) {
  return MARKETPLACE.categories.find(c => c.id === id)?.label || 'Other';
}

/** What a seller keeps from a sale at `priceUsd`. */
export function sellerShare(priceUsd) {
  const p = Number(priceUsd) || 0;
  return Math.round(p * (1 - MARKETPLACE.commissionRate) * 100) / 100;
}

/** USD for display: $40, $12.50. */
export function usd(amount) {
  const n = Number(amount) || 0;
  return `$${n.toLocaleString('en-US', { minimumFractionDigits: Number.isInteger(n) ? 0 : 2, maximumFractionDigits: 2 })}`;
}
